import EFOcats_answer from './efocats_answer.js';
import EFOcats_import_html from '../import/efocats_import_html.js';

/**
 * 回答欄設置の共通処理（入力制限がある場合にテキストを表示とか）
 */
export default class EFOcats_answer_common extends EFOcats_answer {
  /**
   * 回答欄設置
   */
  set(tmp, answer, elem) {
    const input = elem.find('.inner').append(EFOcats_import_html.getValue('common-question', {name: answer.name}));
    this.attr(input.find('input').last().get(0), answer, elem);
  }
}
